import { mergeMap, map, filter } from 'rxjs/operators';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { ApplicationConstants } from './constants/application-constants';
import { AuthService } from './services/auth.service';
import * as fromApp from './store/app.reducers';
import { SetLoggedIn, AuthTokenValidated } from './store/auth/auth.actions';
import { GetDeliveryAddressSuggestions, SetIsContactChecked } from './store/labsys-contact/labsys-contact.actions';
import { environment } from '../environments/environment';
import {
    ActionSettingsChangeAnimationsElements,
    ActionSettingsChangeAnimationsPageDisabled
} from './settings/store/settings.actions';
import { LocalStorageService } from './core/local-storage/local-storage.service';
import browser from 'browser-detect';
import { LoadStatusMessage } from '@app/store/layout/layout.actions';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    hideFooter: boolean;

    constructor(private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        private auth: AuthService,
        private store: Store<fromApp.AppState>,
        public renderer: Renderer2,
        private storageService: LocalStorageService) {
    }

    private static isIEorEdgeOrSafari() {
        return ['ie', 'edge', 'safari'].includes(browser().name);
    }

    ngOnInit() {
        this.hideFooter = !!environment['hideFooter'];

        this.storageService.testLocalStorage();
        const isE2E = !!environment['e2e'];

        if (AppComponent.isIEorEdgeOrSafari() || isE2E) {
            this.store.dispatch(
                new ActionSettingsChangeAnimationsPageDisabled({
                    pageAnimationsDisabled: true
                })
            );

            this.store.dispatch(
                new ActionSettingsChangeAnimationsElements({
                    elementsAnimations: false
                })
            );
        }

        this.renderer.addClass(document.body, `environment-${environment.environment}`);
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data))
            .subscribe((event) => this.titleService.setTitle(((event['pageHeader'])
                ? event['pageHeader']
                : event['title']) + ' » ' + ApplicationConstants.HILL_LABORATORIES));

        // if (this.auth.isAuthenticated()) {
        //   this.store.dispatch(new AuthTokenValidated(this.auth.getAuthTokenFromLocalStorage()));
        // } else {
        //   // this.store.dispatch(new SetIsContactChecked(true));
        //   this.auth.clearLocalStorageValues();
        //   this.auth.clearContactDetails();
        // }

        this.store.dispatch(new LoadStatusMessage());
    }
}
